import { render, staticRenderFns } from "./ActionsCompanyModal.vue?vue&type=template&id=a0a0a7dc&scoped=true&style=font-family%3A%20'roboto'%3B&"
import script from "./ActionsCompanyModal.vue?vue&type=script&lang=js&"
export * from "./ActionsCompanyModal.vue?vue&type=script&lang=js&"
import style0 from "./ActionsCompanyModal.vue?vue&type=style&index=0&id=a0a0a7dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a0a7dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VCol,VIcon,VImg,VLayout,VRow,VSelect,VTextField})
